import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M21.333.318v31.38c-1.654.19-3.502.286-5.333.302a51 51 0 0 1-5.334-.314V.314A51 51 0 0 1 16 0c1.83.016 3.676.12 5.333.318",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M10.667.314v31.372c-1.733-.204-3.255-.508-4.325-.916C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 1.03-4.918 5.476-6.646C7.412.821 8.934.518 10.667.314m10.667 31.384V.318c1.738.207 3.27.52 4.357.945 4.447 1.728 5.476 6.646 5.476 6.646.664 2.757.863 5.582.83 8.107.033 2.493-.2 5.317-.863 8.108 0 0-1.029 4.918-5.477 6.646-1.07.425-2.59.728-4.323.928",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M5.333 13.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M3.361 12a2 2 0 0 0 3.945 0q.027.163.027.333A2 2 0 1 1 3.362 12m1.123-2.396c0 .403.38.73.848.73.469 0 .849-.327.849-.73 0-.291-.212-.328-.212-.437 0-.11.127-.256-.128-.438.128.182-.084.219-.084.401s.084.182.084.328c0 .08-.076.146-.17.146-.093 0-.169-.065-.169-.146 0-.146.17-.291.17-.51s-.043-.292-.17-.474-.34-.328-.17-.474c-.254.073-.127.365-.127.547s-.17.292-.17.51.128.255.128.401c0 .08-.076.146-.17.146s-.17-.065-.17-.146c0-.146.085-.146.085-.328s-.212-.219-.085-.4c-.254.181-.127.327-.127.437s-.212.146-.212.437c0-.291 0 0 0 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#F2C500", d: "M1.333 14.667H3v8.667H1.333zm2 1.333h4v.667h-4z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M4.767 20.919c-.382-.753-.172-1.238.699-1.613.909-.392 1.344-.99 1.275-1.727a2 2 0 0 1-1.975 3.34m-.841-.498A2 2 0 0 1 5.9 17.08c.38.753.17 1.238-.7 1.613-.909.392-1.344.99-1.275 1.727",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#F2C500", d: "M3.333 21.333h4V22h-4zm4.334-6.666h1.667v8.667H7.667z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M3.334 14.667h4l-2 1zm0 7.666h4l-2 1z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagMng = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMng_default = SvgFlagMng;

export { FlagMng_default as default };
